<template>
        <div class="md:tw-m-auto md:tw-container tw-pt-2 tw-flex tw-flex-col tw-justify-center">
                <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
                    <div class="tw-text-gray-900 tw-text-3xl">CAMPAIGNS</div>
                    <div>
                        <TButton class="tw-mb-2 tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500" @click="$router.push({name: 'NewCampaign'})">New Campaign</TButton>
                    </div>
                </div>
                <div class="tw-mb-2">
                    <TInput
                        icon="magnify"
                        v-model="searchText"
                        placeholder="Search by name or tag"
                    ></TInput>
                </div>
                <table class="tw-min-w-full tw-leading-normal">
                    <thead>
                        <tr>
                            <th class="tw-px-5 tw-py-3 tw-border-b-2 tw-border-gray-200 tw-bg-gray-100 tw-text-left tw-text-xs tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wider">
                                Name
                            </th>
                            <th class="tw-hidden md:tw-table-cell tw-px-5 tw-py-3 tw-border-b-2 tw-border-gray-200 tw-bg-gray-100 tw-text-left tw-text-xs tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wider">
                                Editor
                            </th>
                            <th class="tw-px-5 tw-py-3 tw-border-b-2 tw-border-gray-200 tw-bg-gray-100 tw-text-left tw-text-xs tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wider">
                                Created
                            </th>
                            <th class="tw-px-5 tw-py-3 tw-border-b-2 tw-border-gray-200 tw-bg-gray-100 tw-text-left tw-text-xs tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wider">
                                Updated
                            </th>
                            <th class="tw-px-5 tw-py-3 tw-border-b-2 tw-border-gray-200 tw-bg-gray-100 tw-text-left tw-text-xs tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wider">
                                Tags
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            @click="openCampaign(row)"
                            class="hover:tw-bg-gray-100 tw-cursor-pointer tw-bg-white" v-for="row in filteredCampaigns">
                            <td class="tw-px-5 tw-py-5 tw-border-b tw-border-gray-200  tw-text-sm">
                                {{ row.name }}
                            </td>
                            <td class="tw-hidden md:tw-table-cell tw-px-5 tw-py-5 tw-border-b tw-border-gray-200  tw-text-sm">
                                {{ campaignUserName(row) }}
                            </td>
                            <td class="tw-px-5 tw-py-5 tw-border-b tw-border-gray-200  tw-text-sm">
                                {{dayjs(row.created_on)}}
                            </td>
                            <td class="tw-px-5 tw-py-5 tw-border-b tw-border-gray-200  tw-text-sm">
                                {{dayjs(row.latest_update)}}
                            </td>
                            <td class="tw-px-5 tw-py-5 tw-border-b tw-border-gray-200  tw-text-sm">
                                <span v-for="tag in row.tags" class="tw-mx-1 tw-bg-gray-100 tw-px-2 tw-py-1 tw-rounded">{{tag}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!--
                <b-table
                    :data="filteredCampaigns"
                    striped
                    hoverable
                    :row-class="() => { return { 'is-clickable': true } }"
                    :loading="loading"
                    @click="openCampaign"
                >
                    <b-table-column
                        header-class="bt-header"
                        cell-class="bt-cell"
                        label="Name">
                        <template v-slot:header="{ column }">
                            <div class="is-flex is-align-items-center">
                                <b-icon icon="bullhorn" size="is-small" class="ml-0 mr-2"></b-icon>
                                {{column.label}}
                            </div>
                        </template>
                        <template v-slot="props">
                            {{ props.row.name }}
                        </template>
                    </b-table-column>
                    <b-table-column
                        header-class="bt-header"
                        cell-class="bt-cell"
                        label="Created By">
                        <template v-slot:header="{ column }">
                            <div class="is-flex is-align-items-center">
                                <b-icon icon="account" size="is-small" class="ml-0 mr-2"></b-icon>
                                {{column.label}}
                            </div>
                        </template>
                        <template v-slot="props">
                            {{ campaignUserName(props.row) }}
                        </template>
                    </b-table-column>
                    <b-table-column
                        header-class="bt-header"
                        cell-class="bt-cell"
                        label="Created">
                        <template v-slot:header="{ column }">
                            <div class="is-flex is-align-items-center">
                                <b-icon icon="calendar-plus" size="is-small" class="ml-0 mr-2"></b-icon>
                                {{column.label}}
                            </div>
                        </template>
                        <template v-slot="props">
                            <div :title="tooltip(props.row.created_on)" style="cursor: auto;">
                                {{dayjs(props.row.created_on)}}
                            </div>
                        </template>
                    </b-table-column>
                    <b-table-column
                        header-class="bt-header"
                        cell-class="bt-cell"
                        label="Updated">
                        <template v-slot:header="{ column }">
                            <div class="is-flex is-align-items-center">
                                <b-icon icon="calendar-edit" size="is-small" class="ml-0 mr-2"></b-icon>
                                {{column.label}}
                            </div>
                        </template>
                        <template v-slot="props">
                            <div v-if="props.row.latest_update" :title="tooltip(props.row.latest_update)" style="cursor: auto;">
                                {{dayjs(props.row.latest_update)}}
                            </div>
                        </template>
                    </b-table-column>
                    <b-table-column
                        header-class="bt-header"
                        cell-class="bt-cell"
                        label="Tags">
                        <template v-slot:header="{ column }">
                            <div class="is-flex is-align-items-center">
                                <b-icon icon="shape" size="is-small" class="ml-0 mr-2"></b-icon>
                                {{column.label}}
                            </div>
                        </template>
                        <template v-slot="props">
                            <span v-for="tag in props.row.tags" class="mx-1 tag">{{tag}}</span>
                        </template>
                    </b-table-column>
                </b-table>
                -->
    </div>
</template>

<script>
import axios          from 'axios';
import dayjs          from 'dayjs';
import relativeTime   from 'dayjs/plugin/relativeTime';
import utc            from 'dayjs/plugin/utc';
import timezone       from 'dayjs/plugin/timezone'; 
import advancedFormat from 'dayjs/plugin/advancedFormat';

import {
    TInput,
    TButton
} from '@roonlabs/vue-tailwind';

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)

export default {
    components: { TButton, TInput },
    data() {
        return {
            searchText:  '',
            campaigns:   [],
            loading:     true,
        }
    },

    methods: {
        openCampaign({ campaign_id }) {
            this.$router.push({name: 'Campaign', params: { campaign_id }});
        },
        async getCampaigns() {
            this.loading = true;
            try {
                const res         = await axios.get('/api/1/campaigns')
                const {campaigns} = res.data;
                this.campaigns    = campaigns;
            } catch (e) {
                console.log(e)
            }
            this.loading = false;
        },
        dayjs(dateobject) {
            return dayjs().to(dateobject);
        },
        tooltip(dateobject) {
            return dayjs(dateobject).format("dddd, MMMM D, YYYY h:mm A z")
        },
        campaignUserName(c) {
            if ( !c.user ) {
                return c.created_by
            } else {
                const name = (c.user.firstname || '') + ' ' + (c.user.lastname || '')
                if ( name.replace(' ') == '' ) return c.created_by;
                return name;
            }
        }
    },
    computed: {
        filteredCampaigns() {
            if ( !this.searchText ) return this.campaigns.sort((a,b) => new Date(b.latest_update).getTime() - new Date(a.latest_update).getTime())

                return this.campaigns
                    .filter ( c => {
                        c.sort_index = (c.name + ( c.tags || [] ).join(' ')).toLowerCase().indexOf(this.searchText.toLowerCase());
                        return c.sort_index !== -1
                    })
                    .sort( (a,b) => a.sort_index - b.sort_index )
        }
    },

    created() {
        this.getCampaigns();
    }
}
</script>
